export default __webpack_public_path__ + "static/media/customers.5dc3a0c9.png";